// Layout + formatting helpers for the full-screen Blasts feed.

// Below this feed width the player goes edge-to-edge (phone, TikTok-style).
// At or above it (tablet / desktop) the video sits in a centered 9:16 card
// with the action rail beside it.
export const BLAST_WIDE_MIN_WIDTH = 600;

const ASPECT = 9 / 16;
const CARD_MARGIN_Y = 16;
// Room kept on each side of the card for the action rail.
const SIDE_RESERVE = 96;
// Room the action rail plus the up/down arrows on the right edge need together.
const ARROWS_RESERVE = 160;

/**
 * Decides how a blast is laid out inside a feed of the given size.
 * @returns {{ mode: 'phone' | 'wide', cardWidth: number, cardHeight: number, showArrows: boolean }}
 */
export function getBlastLayout({ width, height }) {
  if (!width || !height || width < BLAST_WIDE_MIN_WIDTH) {
    return { mode: 'phone', cardWidth: width || 0, cardHeight: height || 0, showArrows: false };
  }

  let cardHeight = Math.max(0, height - CARD_MARGIN_Y * 2);
  let cardWidth = cardHeight * ASPECT;
  const maxCardWidth = width - SIDE_RESERVE * 2;
  if (cardWidth > maxCardWidth) {
    cardWidth = Math.max(0, maxCardWidth);
    cardHeight = cardWidth / ASPECT;
  }

  // Arrows only when they fit beside the rail; touch tablets can always swipe.
  const showArrows = (width - cardWidth) / 2 >= ARROWS_RESERVE;

  return { mode: 'wide', cardWidth: Math.round(cardWidth), cardHeight: Math.round(cardHeight), showArrows };
}

/** 999 → "999", 1200 → "1.2K", 3400000 → "3.4M". */
export function formatBlastCount(n) {
  const value = Number(n) || 0;
  if (value < 1000) return String(value);
  if (value < 1000000) return `${trimDecimal(value / 1000)}K`;
  return `${trimDecimal(value / 1000000)}M`;
}

function trimDecimal(v) {
  return (Math.floor(v * 10) / 10).toFixed(1).replace(/\.0$/, '');
}

/** Wider-than-portrait videos are letterboxed instead of cropped. */
export function blastObjectFit(videoWidth, videoHeight) {
  if (!videoWidth || !videoHeight) return 'cover';
  return videoWidth / videoHeight > 0.75 ? 'contain' : 'cover';
}
